

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { fetchDistricts } from "../../redux/actions/locationActions";
import { updateMunicipality } from "../../redux/actions/municipalitiesActions";

const EditMunicipalityModal = ({ selectedMunicipality, onClose }) => {
  const dispatch = useDispatch();
  const { districts } = useSelector((state) => state.location);

  const [formData, setFormData] = useState({
    id: null,
    name: "",
    district_id: null,
    status: "active",
  });

  useEffect(() => {
    dispatch(fetchDistricts());
  }, [dispatch]);

  useEffect(() => {
    if (selectedMunicipality) {
      setFormData({
        id: selectedMunicipality.id,
        name: selectedMunicipality.name || "",
        district_id: selectedMunicipality.district_id,
        status: selectedMunicipality.status || "active",
      });
    }
  }, [selectedMunicipality]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "district_id" || name === "id" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.id || !formData.name || !formData.district_id || !formData.status) {
      toast.error("All fields are required.");
      return;
    }

    try {
      await dispatch(updateMunicipality(formData));
      toast.success("Municipality updated successfully");
      if (onClose) onClose(); // Close modal after update
    } catch (err) {
      toast.error(err?.response?.data?.meta?.message || "Update failed");
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow space-y-4 relative">
      {/* Close Button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-2 right-2 text-gray-600 hover:text-red-600 text-xl font-bold"
      >
        &times;
      </button>

      <form onSubmit={handleSubmit} className="space-y-4 mt-4">
        <div>
          <label className="block text-sm font-medium">Municipality Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">District</label>
          <select
            name="district_id"
            value={formData.district_id || ""}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          >
            <option value="">-- Select District --</option>
            {districts.map((dist) => (
              <option key={dist.id} value={dist.id}>
                {dist.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium">Status</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-300 text-gray-800 py-2 px-4 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
          >
            Update Municipality
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditMunicipalityModal;
